module.exports = __webpack_public_path__ + "static/img/Tevita-Tatola.91911db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tevita-Tatola.jpg
// module id = T4it
// module chunks = 0